import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import {connect} from "react-redux";
import ConfigurationFavorite from "./configuration-favorite/ConfigurationFavorite"
import { getFavoriteConfigurations, isLoading } from '../../../store/cut-to-size/reducers'
import { fetchFavoriteConfigurations, removeFavoriteConfiguration, cloneConfiguration, cloneGroupedConfiguration } from '../../../store/cut-to-size/actions'
import { getCmOrInches, getMeasureFromMetric } from '../../../helpers'

const ConfigurationFavoriteScreen = props => <ConfigurationFavorite {...props} />

const mapStateToProps = (state, ownprops) => {
    return {
        favoriteConfigurations: getFavoriteConfigurations(state),
        isLoading: isLoading(state),
        measureFromMetric: (measure, decimals) => getMeasureFromMetric(measure, decimals, state),
        units: getCmOrInches(state)
    }
}

const mapDispatchToProps = (dispatch, ownprops) => {
    return {
        fetchFavoriteConfigurations: (page, size) => dispatch(fetchFavoriteConfigurations(page, size)),
        removeFavoriteConfiguration: (ref) => dispatch(removeFavoriteConfiguration(ref)),
        cloneConfiguration: (ref, newConfigName) => dispatch(cloneConfiguration(ref, newConfigName)),
        cloneGroupedConfiguration: (parentRef, newConfigName) => dispatch(cloneGroupedConfiguration(parentRef, newConfigName)),
        // Analytics triggers
        triggerCopyConfiguration: () => dispatch({ type: 'COPY_FAVORITE_CONFIGURATION' }),
        triggerDeleteConfiguration: () => dispatch({ type: 'DELETE_FAVORITE_CONFIGURATION' }),
    }
}

defineMessages({
    delete_this_configuration: {
        id: 'delete_this_configuration',
        description: 'delete_this_configuration',
        defaultMessage: 'Delete this configuration'
    },
    this_action_is_permanent_and_you_will_not_be_able_to_recover_your_saved_settings: {
        id: 'this_action_is_permanent_and_you_will_not_be_able_to_recover_your_saved_settings',
        description: 'this_action_is_permanent_and_you_will_not_be_able_to_recover_your_saved_settings',
        defaultMessage: 'This action is permanent, and you will not be able to recover your saved settings.'
    },
    are_you_sure_you_want_to_delete_the_configuration: {
        id: 'are_you_sure_you_want_to_delete_the_configuration',
        description: 'are_you_sure_you_want_to_delete_the_configuration',
        defaultMessage: 'Are you sure you want to delete the configuration?'
    },
    duplicate_this_configuration: {
        id: 'duplicate_this_configuration',
        description: 'duplicate_this_configuration',
        defaultMessage: 'Duplicate this configuration'
    },
    extra: {
        id: 'extra',
        description: 'extra',
        defaultMessage: 'Extra'
    },
    left: {
        id: 'left',
        description: 'left',
        defaultMessage: 'Left'
    },
    right: {
        id: 'right',
        description: 'right',
        defaultMessage: 'Right'
    },
    washbasins: {
        id: 'washbasins',
        description: 'washbasins',
        defaultMessage: 'Washbasins'
    },
})

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(ConfigurationFavoriteScreen)
)
